import React from 'react';
import me from '../images/me.png';
import { Link } from 'react-router-dom';
const About = () => {
    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-5">
                    <img src={me} className="aboutPictue img-fluid" alt="rajon ahmed" />
                    <h1 className="textLight">Rajon Ahmed</h1>
                    <p style={{ color: '#a8b2d1' }}>For the past two and half years, I've worked as a Front-end Developer utilizing the most cutting-edge technology and tools. I combine my love for usability and user experience with technical skills. I constantly prioritize product quality and a professional codebase as well as a desire to learn and improve from my surroundings. I'm looking forward to connecting with like-minded folks who are passionate about technology.</p>
                    <div className="mt-4">
                        <a href="https://drive.google.com/file/d/1KgDtVnEKWXlVeEt9IHfaATiw4vEw8lJ_/view" target='_blank' rel="noreferrer"><button type="button" className="me-4 btn btn-success"> My Resume</button></a>
                        <a href="https://www.linkedin.com/in/rajon-ahmed749/" rel="noreferrer" target="_blank"><button type="button" className="btn btn-outline-success">Hire me</button></a>
                    </div>
                </div>
                <div className="col-md-5 mt-2">
                    <div class="my-5">
                        <h4 class="page-title mb-3">Expertise:</h4>
                        <div class="technology">
                            <span>JavaScript</span>
                            <span>ES6</span>
                            <span>React.js</span>
                            <span>React Native</span>
                            <span>REST API</span>
                            <span>Node.js</span>
                            <span>Express.js</span>
                            <span>MongoDB</span>
                        </div>
                        <h4 class="page-title mt-5 mb-3">Comfortable:</h4>
                        <div class="technology">
                            <span>Next.js</span>
                            <span>Typescript</span>
                            <span>Redux.js</span>
                            <span>Material-UI</span>
                            <span>Ant Design</span>
                        </div>
                        <h4 class="page-title mt-5 mb-3">Tools:</h4>
                        <div class="technology">
                            <span>Git</span>
                            <span>Github</span>
                            <span>Expo</span>
                            <span>Firebase</span>
                            <span>NPM</span>
                            <span>Netlify</span>
                            <span>Heroku</span>
                            <span>VS Code</span>
                            <span>Chrome dev tool</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-5 mx-auto">
                <div className="mt-5 col-md-8 text-white mx-auto text-center">
                    <h4>Visit my recent projects</h4>
                    <Link to="/works" style={{ color: '#64ffda' }}> Click here</Link>
                </div>
            </div>

        </div>
    );
};

export default About;